import React from 'react';
import { StreamingPlatform } from '../../types/streaming';
import PlatformIcon from './PlatformIcon';

interface Platform {
  id: StreamingPlatform;
  name: string;
  color: string;
  enabled: boolean;
}

const platforms: Platform[] = [
  { id: 'tiktok', name: 'TikTok', color: '#00f2ea', enabled: true },
  { id: 'youtube', name: 'YouTube', color: '#FF0000', enabled: true },
  { id: 'twitch', name: 'Twitch', color: '#9146FF', enabled: true }
];

interface PlatformSelectorProps {
  onSelect: (platform: StreamingPlatform) => void;
  disabled?: boolean;
}

export const PlatformSelector: React.FC<PlatformSelectorProps> = ({
  onSelect,
  disabled = false
}) => {
  return (
    <div className="space-y-2">
      <h3 className="text-sm font-semibold text-white mb-3">Select Platform</h3>
      {platforms.map((platform) => (
        <button
          key={platform.id}
          onClick={() => platform.enabled && onSelect(platform.id)}
          disabled={disabled || !platform.enabled}
          className={`
            w-full px-3 py-2.5 flex items-center gap-3 transition-all
            ${platform.enabled
              ? 'bg-gray-800 hover:bg-gray-700 cursor-pointer'
              : 'bg-gray-900 opacity-50 cursor-not-allowed'
            }
            ${disabled ? 'opacity-50 cursor-not-allowed' : ''}
          `}
          style={{ borderLeft: `3px solid ${platform.color}` }}
        >
          <PlatformIcon platform={platform.id} className="w-5 h-5 text-white flex-shrink-0" />
          <div className="flex-1 text-left">
            <div className="text-xs font-semibold text-white">{platform.name}</div>
            <div className="text-gray-400" style={{ fontSize: '10px' }}>
              {platform.enabled ? `Connect to ${platform.name} live stream` : 'Coming soon'}
            </div>
          </div>
          {platform.enabled && (
            <svg className="w-3.5 h-3.5 text-gray-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          )}
        </button>
      ))}
    </div>
  );
};

export default PlatformSelector;
